<div class="flex-column flex-1 gap">
    <div class="flex gap align-items-center">
        <app-select-button
            [form]="filterForm" id="type" prefix="waitingList.filter.type."
            [options]="typeOptions()"
        ></app-select-button>

        <app-switch-input id="active" [form]="filterForm" label="waitingList.filter.active"></app-switch-input>
    </div>

    @if (filterForm.value.type === 'clients') {
        <app-table
            #clientsTable
            tableKey="waitingListClients"
            [translatePrefix]="prefix"
            [columns]="clientsColumns()"
            [gridData]="$any(store.data.getWaitingListItems())"
            [refreshCallback]="store.api.getWaitingListItems"
            [refreshCallbackFragment]="clientsWaitingListFrag"
            [additionalFilter]="$any(additionalFilter())"
            [showColumnVisiblity]="true"
            [hideCheckboxes]="true"
            [defaultSorters]="[{ column: 'onRecordFrom', direction: 'ASC' }]"
            (createCallback)="openClientDetail()"
            (detailCallback)="openClientDetail($event)"
        >
            <ng-template pTemplate="offer" let-data="data" let-item="item">
                @if (item.offerId) {
                    <p-chip
                        [label]="data | formatOfferDuration:true:item.applications"
                        [pTooltip]="data.name"
                        [ngStyle]="{ 'background-color': data.color || DEFAULT_TAG_COLOR, 'border-radius': '16px', color: (data.color || DEFAULT_TAG_COLOR) | colorContrast }"
                    ></p-chip>
                }
            </ng-template>
        </app-table>
    } @else if (filterForm.value.type === 'attendants') {
        <app-table
            #attendantsTable
            tableKey="waitingListAttendants"
            [translatePrefix]="prefix"
            [columns]="attendantsColumns()"
            [gridData]="$any(store.data.getWaitingListItems())"
            [refreshCallback]="store.api.getWaitingListItems"
            [refreshCallbackFragment]="attendantsWaitingListFrag"
            [additionalFilter]="$any(additionalFilter())"
            [showColumnVisiblity]="true"
            [hideCheckboxes]="true"
            [defaultSorters]="[{ column: 'ratingPoints', direction: 'DESC' }]"
            (detailCallback)="openAttendantDetail($event)"
        >
            <ng-template pTemplate="form" let-data="data">
                @for (form of data; track $index; let i = $index) {
                    {{ 'service.serviceFormShortCutEnum.' + form | translate }}
                    @if (i < data.length - 1) {
                        <span>, </span>
                    }
                }
            </ng-template>
        </app-table>
    }
</div>
